// extracted by mini-css-extract-plugin
export default {"products":"LA-z","card":"MA-z","oosMessaging":"NA-z"};